<template>
  <div class="home">
    <Banner :banner="bannerMovie" />
    <MoviesListVue :movies="popularMovies" :discription="true" />
  </div>
</template>

<script>
import Banner from "@/components/Banner.vue";
import MoviesListVue from "@/components/MoviesList.vue";
import { mapActions, mapGetters, mapState } from 'vuex';
export default {
  name: 'HomeView',
  mounted() {
    document.title = 'iMovie — Watch Popular Movies Online'
    document.querySelector('meta[name="description"]')?.setAttribute('content', 'Watch the most popular movies online for free. New releases, top rated and latest films.')
  },
  components: {
    Banner,
    MoviesListVue
  },
  methods: {
    ...mapActions({
      fetchPopularMovies: 'home/fetchPopularMovies',
    }),
  },
  computed: {
    ...mapState({
      popularMovies: state => state.home.popularMovies,
      bannerMovie: state => state.home.bannerMovie
    }),
    ...mapGetters({
      getPopularMovies: 'home/getPopularMovies',
    })
  },
  watch: {
    '$store.state.locale'() {
      this.fetchPopularMovies();
    }
  },
  mounted() {
    this.fetchPopularMovies();
  },
}
</script>

<style>

</style>
